// INVOICE LIST
export const INVOICE_LIST_REQUEST = 'INVOICE_LIST_REQUEST';
export const INVOICE_LIST_SUCCESS = 'INVOICE_LIST_SUCCESS';
export const INVOICE_LIST_FAIL = 'INVOICE_LIST_FAIL';

// INVOICE CREATE
export const INVOICE_CREATE_REQUEST = 'INVOICE_CREATE_REQUEST';
export const INVOICE_CREATE_SUCCESS = 'INVOICE_CREATE_SUCCESS';
export const INVOICE_CREATE_FAIL = 'INVOICE_CREATE_FAIL';
